import { type Editor, Extension } from "@tiptap/core";
import autocomplete, { type AutocompleteAction } from "prosemirror-autocomplete";

export const MENTION_INPUT_DATA_ATTR = "data-mention-input";
export type MentionItemType = {
  text: string;
};

export const MentionsExtension = (opts: {
  autocompleteActionsHandler: (event: {
    action: AutocompleteAction;
    editor: Editor;
  }) => Promise<void>;
}) =>
  Extension.create({
    // Properties related to rendering the node
    name: "mentionPicker",
    group: "inline",
    atom: true,
    inline: true,

    addAttributes() {
      return {
        type: "",
        associatedCollection: "",
        data: {},
      };
    },
    // addNodeView() {
    //   return SolidNodeViewRenderer(MentionNode);
    // },
    // renderText({ node }) {
    //   const attrs = node.attrs as MentionItemType;
    //   const id = attrs.data.id;
    //   const name = attrs.type === "asset" ? attrs.data.originalFilename : attrs.data.label;
    //   return `@[${id}]"${name}"`;
    // },
    // renderHTML({ node }) {
    //   const attrs = node.attrs as MentionItemType;
    //   const id = attrs.data.id;
    //   const name = attrs.type === "asset" ? attrs.data.originalFilename : attrs.data.label;
    //   return ["span", {}, `@[${id}]"${name}"`];
    // },
    addProseMirrorPlugins() {
      return autocomplete({
        triggers: [
          {
            trigger: "@",
            cancelOnFirstSpace: false,
            name: "mentionInput",
            decorationAttrs: {
              class: "rounded-lg bg-canvas border border-primary-border",
              [MENTION_INPUT_DATA_ATTR]: "true",
            },
          },
        ],
        reducer: (action) => {
          opts.autocompleteActionsHandler({ action, editor: this.editor });
          return true;
        },
      });
    },
  });
